<i18n src="./../../i18n/buy_online.json"></i18n>

<template>
  <div id="buy-page">
    <vue-headful
        :title="$t('pageTitle')"
        :description="$t('pageDescription')"
        :url="pageUrl"/>
    <div class="container-fluid" v-if="loaded">
      <navigation-bar/>

      <div id="paralax-subpage-section" class="lazy jumbotron mt-page-nav-image" data-bg="/assets/mt-cart-header-image.jpg">
        <div class="container">
        </div>
      </div>

      <div class="container-fluid mt-subpage-section m-0 p-0">
        <div class="container-fluid m-0 p-0">
          <div class="lazy container-fluid">

              <div class="container">
                <div class="content-container p-3 pt-5">

                    <div class="container mb-5 mt-5" v-html="content.topFragment"/>

                    <div class="row no-gutters justify-content-center pt-4 pb-5">
                      <div class="mt-md-only col-auto">
                        <img class="lazy" :data-src="$t('buyHorizontal')" usemap="#mt-buy-horizontal-map">
                        <map name="mt-buy-horizontal-map">
                          <area shape="rect" v-on:click="goToOffer" on :coords="$t('buyHorizontalClickableArea')">
                          <area shape="rect" v-on:click="goToOffer" coords="80,0,160,100">
                        </map>
                      </div>
                      <div class="mt-to-md-only col-auto">
                        <img class="lazy" :data-src="$t('buyVertical')" usemap="#mt-buy-vertical-map">
                        <map name="mt-buy-vertical-map">
                          <area shape="rect" v-on:click="goToOffer" coords="150,30,260,45">
                          <area shape="rect" v-on:click="goToOffer" coords="45,0,105,65">
                        </map>
                      </div>
                    </div>

                    <div class="container mb-5 mt-5" v-html="content.middleFragment"/>

                    <div class="row no-gutters justify-content-center pt-4 pb-5">
                      <div class="mt-md-only col-auto">
                        <img class="lazy" :data-src="$t('checkoutHorizontal')" usemap="#mt-checkout-horizontal-map">
                        <map name="mt-checkout-horizontal-map">
                          <area shape="rect" v-on:click="goToBasket" coords="15,110,245,125">
                          <area shape="rect" v-on:click="goToBasket" coords="75,20,175,100">
                        </map>
                      </div>
                      <div class="mt-to-md-only col-auto">
                        <img class="lazy" :data-src="$t('checkoutVertical')" usemap="#mt-checkout-vertical-map">
                        <map name="mt-checkout-vertical-map">
                          <area shape="rect" v-on:click="goToBasket" coords="150,5,275,45">
                          <area shape="rect" v-on:click="goToBasket" coords="35,0,100,55">
                        </map>
                      </div>
                    </div>

                    <div class="container mb-5 mt-5" v-html="content.bottomFragment"/>

              </div>
              <main-footer/>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import NavigationBar from "@/components/commons/NavigationBar";
import MainFooter from "@/components/commons/MainFooter";
import axios from "axios";
import {Const} from "@/main";
import $ from "jquery";
import LazyLoad from "vanilla-lazyload";

var lazyLoadInstance = new LazyLoad({
  elements_selector: ".lazy"
});

export default {
  name: "ContactPage",
  components: {MainFooter, NavigationBar},
  data () {
    return {
      content: {},
      loaded: false,
      pageUrl: Const.HOST + this.$route.path,
      locale: this.$i18n.locale
    }
  },
  methods: {
    goToOffer() {
      this.$router.push({name: 'offer'})
    },
    goToBasket() {
      this.$router.push({name: 'basket'})
    }
  },
  mounted() {
    axios.get(`${Const.API_HOST}/${this.locale}/content/buyOnline`)
        .then(function (response) {
          return response.data;
        }).catch(function (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }).then(body => {
      this.content = body
      this.loaded = true

      this.$nextTick(() => {
        lazyLoadInstance.update()
      })
    });

    $(document).scroll(function () {
      var $nav = $(".navbar-light");
      $nav.removeClass('initial');
      $nav.toggleClass('scrolled', $(this).scrollTop() > $nav.height());
    });
  }
}
</script>

<style scoped>
area {
  cursor: pointer;
}
#paralax-subpage-section {
  height: 200px;
}
</style>